import { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';
import {
  trackInternalLinkEvent,
  TrackingEvents,
  trackEventWithParams,
  trackViewChangeEvent,
  trackEvent,
  trackInitialStateEvent,
} from './trackingService';
import {
  MapAppSearchResultEnum,
  MapAppSearchResultElementNameEnum,
  searchTypeEnum,
} from '../models/tracking-data';
import { Dealer } from '../models/dealer';

export function trackInitialState(
  // eslint-disable-next-line
  trackingService: any,
  searchGeolocation: Coordinates,
  query: string | null,
  preferredDealer: Dealer | null,
) {
  if (!(searchGeolocation.lng !== 0 && searchGeolocation.lat !== 0) || !query) {
    trackInitialStateEvent(trackingService, TrackingEvents.VIEW_CHANGE, preferredDealer, true);
  }
}

export function trackPlaceSelectionAction(
  // eslint-disable-next-line
  trackingService: any,
  placeName: string,
  component: string,
  pos: number | undefined,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.LOCATION_SUBMIT,
    component,
    placeName,
    placeName,
    MapAppSearchResultElementNameEnum.TEXT_LINK,
    pos,
    targetURL,
  );
}

export function trackRadiusChangeAction(
  // eslint-disable-next-line
  trackingService: any,
  label: string,
  value: string,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.CHANGE_RADIUS,
    component,
    label,
    value,
    MapAppSearchResultElementNameEnum.DROP_DOWN,
    '',
    targetURL,
  );
}

export function trackDealerSelectionAction(
  // eslint-disable-next-line
  trackingService: any,
  dealerName: string,
  component: string,
  searchTerm: string,
  pos: number | undefined,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.QUICK_RESULT_SUBMIT,
    component,
    dealerName,
    searchTerm,
    MapAppSearchResultElementNameEnum.TEXT_LINK,
    pos,
    targetURL,
  );
}
// eslint-disable-next-line
export function trackDealerDetailsDisplayAction(trackingService: any, dealer: Dealer) {
  trackEventWithParams(trackingService, TrackingEvents.VIEW_CHANGE, {
    dealerID: dealer.dealerId,
    dealerName: dealer.name,
    partnerServiceDetails: dealer.services,
    matPrimaryCode: dealer.matPrimaryCode,
    kvpsPartnerKey: dealer.kvpsPartnerKey,
  });
}

export function trackAddFilterAction(
  // eslint-disable-next-line
  trackingService: any,
  label: string,
  value: string,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.ADD_FILTER,
    component,
    label,
    value,
    MapAppSearchResultElementNameEnum.TEXT_LINK,
    '',
    targetURL,
  );
}
export function trackRemoveFilterAction(
  // eslint-disable-next-line
  trackingService: any,
  label: string,
  value: string,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.REMOVE_FILTER,
    component,
    label,
    value,
    MapAppSearchResultElementNameEnum.TEXT_LINK,
    '',
    targetURL,
  );
}

export function trackFilterCancelAction(
  // eslint-disable-next-line
  trackingService: any,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.DO_NOT_STORE_FILTER,
    component,
    '',
    '',
    MapAppSearchResultElementNameEnum.ICON,
    '',
    targetURL,
  );
}

export function trackMapMarkerClickAction(
  // eslint-disable-next-line
  trackingService: any,
  dealerName: string,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.MAP_PIN_CLICK,
    component,
    dealerName,
    '',
    MapAppSearchResultElementNameEnum.ICON,
    '',
    targetURL,
  );
}

export function trackMapSearchFormSubmitAction(
  // eslint-disable-next-line
  trackingService: any,
  searchText: string,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.SUBMIT,
    component,
    '',
    searchText,
    MapAppSearchResultElementNameEnum.OTHER,
    '',
    targetURL,
  );
}

export function trackResultListDealerSelectionAction(
  // eslint-disable-next-line
  trackingService: any,
  dealerName: string,
  component: string,
  searchTerm: string,
  pos: number | undefined,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.RESULT_SUBMIT,
    component,
    dealerName,
    searchTerm,
    MapAppSearchResultElementNameEnum.TEXT_LINK,
    pos,
    targetURL,
  );
}

export function trackSearchThisAreaButtonAction(
  // eslint-disable-next-line
  trackingService: any,
  btnText: string,
  component: string,
  targetURL: string,
) {
  trackInternalLinkEvent(
    trackingService,
    TrackingEvents.MAP_APP_SEARCH,
    MapAppSearchResultEnum.SEARCH_THIS_AREA,
    component,
    btnText,
    '',
    MapAppSearchResultElementNameEnum.BUTTON,
    '',
    targetURL,
  );
}

export function trackSearchByTermQuery(
  // eslint-disable-next-line
  trackingService: any,
  query: string,
  resultsLength: number,
  selectedFilters: string[],
  searchResults: Dealer[],
) {
  trackViewChangeEvent(
    trackingService,
    TrackingEvents.VIEW_CHANGE,
    query,
    resultsLength,
    searchTypeEnum.BY_TERM,
    selectedFilters,
    searchResults,
    null,
    false,
  );
}

export function trackSearchByGeolocationQuery(
  // eslint-disable-next-line
  trackingService: any,
  query: string,
  resultsLength: number,
  selectedFilters: string[],
  searchResults: Dealer[],
) {
  trackViewChangeEvent(
    trackingService,
    TrackingEvents.VIEW_CHANGE,
    query,
    resultsLength,
    searchTypeEnum.GEOLOCATION,
    selectedFilters,
    searchResults,
    null,
    false,
  );
}

export function trackSearchByZipCodeQuery(
  // eslint-disable-next-line
  trackingService: any,
  query: string,
  resultsLength: number,
  selectedFilters: string[],
  searchResults: Dealer[],
) {
  trackViewChangeEvent(
    trackingService,
    TrackingEvents.VIEW_CHANGE,
    query,
    resultsLength,
    searchTypeEnum.BY_ZIPCODE,
    selectedFilters,
    searchResults,
    null,
    false,
  );
}
// eslint-disable-next-line
export function trackUserLocationAction(trackingService: any, action: TrackingEvents) {
  trackEvent(trackingService, action);
}

export function trackAppReadyEvent(
  // eslint-disable-next-line
  trackingService: any,
  // eslint-disable-next-line
  componentAdditions: any,
  componentName: string,
) {
  trackEventWithParams(
    trackingService,
    TrackingEvents.APP_READY,
    componentAdditions,
    componentName,
  );
}
